export function setCookie(cname: string, cvalue: string, exdays: number = 1000) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export function getCookie(cname: string) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function deleteCookie(cname: string) {
  document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
}

export const cookies = [
  'functional-cookies',
  'analytical-cookies',
  'video-cookies',
  'tracking-cookies',
  // 'readspeaker-cookies',
] as const

// Name of the cookie that records which consent version a visitor last consented under.
export const consentVersionCookie = 'consent-version'

// Bump this whenever the meaning of consent changes (e.g. new cookie statement terms,
// new tools such as Spotler Activate, or a changed cookie-to-consent mapping).
// A mismatch with the stored version clears the stored consent and shows the cookie bar again.
export const CONSENT_VERSION = '2'

export type Cookie = (typeof cookies)[number]

export const requiredCookies: Cookie[] = ['functional-cookies', 'analytical-cookies']

export type Accepted = 'yes' | 'no'

export type Cookies = Map<Cookie, Accepted>
